import { Command } from 'commander'
import figlet from 'figlet'
import { docs } from './commands/docs'
import config from './config.json'

async function main() {
	console.log(figlet.textSync('Hashnode', { horizontalLayout: 'fitted' }))

	const program = new Command()
		.name('hashnode')
		.description('CLI for Hashnode Products')
		.version(config.version || '1.0.0', '-v, --version', 'display the version number')

	program.addCommand(docs)

	program.parse()
}

main()
